import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../environments/environment';
import { NavigationEnd, Router, ActivatedRoute, ParamMap, NavigationStart } from '@angular/router';
import { SpinnerOverlayService } from './spinner-overlay.service';
import { Title } from '@angular/platform-browser';
import jwtDecode from 'jwt-decode';
import { Cookie } from 'ng2-cookies';
import { AuthService } from '../app/login/auth/auth.service';
import { OptimizeService } from './shared/optimize.service';
import { IdletimeService } from './shared/services/idletime.service';
import { SharedService } from './shared';
import { PixelService } from './shared/services/pixel.service';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AppHubService } from './techopsv4/services/appHubV4Service';
import { SharedAuthService } from './shared/shared.auth.service';

declare global {
  interface Window {
    Rakanto: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [IdletimeService],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'tcmhubv2';
  loading = false;
  loggedUser = JSON.parse(sessionStorage.getItem('currentUser')) || true;
  sidebar = false;
  tcmhub = true;
  padu = false;
  title1 = 'TCM Hub';
  title2 = 'Application Hub';
  title3 = 'TechOps Hub';
  isPathApplicationInsights: boolean = false;
  appLoader: boolean;
  loggedIn;
  currentPath: boolean = false;
  path: string = '';
  showSpinner: boolean = false;
  successSSOLogin: boolean = false;
  MsId =this.sharedAuthService.getMsid()
  code: any;
  accessToken: any;
  idToken: any;
  result: any;
  ssoenabled: boolean = false;
  public browserRefresh = false;
  idleTimerLeft: string;
  idelTimeSeconds: string;
  secondTimerLeft: string;
  timeRemain: number;
  FULL_DASH_ARRAY = 283;
  intialvalue = 120;
  currentUrl: any = '';
  role = 'Others';
  static isBrowser = new BehaviorSubject<boolean>(null);
  userRoleSet = true;
  private tokenRefreshTimeout: any;

  constructor(
    private titleService: Title,
    private router: Router,
    private spinnerService: SpinnerOverlayService,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private tcmoptimise: OptimizeService,
    private ngIdle: IdletimeService,
    private sharedService: SharedService,
    private PixelService: PixelService,
    private AppHubv4Service: AppHubService,
    private sharedAuthService: SharedAuthService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    AppComponent.isBrowser.next(isPlatformBrowser(this.platformId));
    console.log('Environment Name :' + environment.environmentName + ' api Url: ' + environment.apiUrl);
  }
  @HostListener('document:click', ['$event.target'])
  handleDocumentClicks(target) {
    const event = { url: '' };
    let title = target.getAttribute('Pixel-title');
    event.url = window.location.pathname || title;
    let Tracker = target.getAttribute('Pixel-tracking') ? true : false;
    const tabcheck = !target['parentNode']?.['parentNode']?.['parentNode']?.['parentNode']?.['parentNode']?.['parentNode']
      ? target['parentNode']?.['parentNode']?.['parentNode']?.['parentNode']?.['parentNode']?.[
        'parentNode'
      ]?.getAttribute('Pixel-tracking')
      : false;
    if (tabcheck) {
      Tracker = true;
      title = target.innerText;
    }
    console.log(Tracker, title);
    if (Tracker) this.PixelService.startPixelTracking(event, 'click', title);
  }
  ngOnInit() {
    this.setupRouterSubscription();
    
    this.spinnerService.showSpinnerSubject.subscribe(val => {
      this.appLoader = val;
    });
    this.loggedIn = this.sharedAuthService.getMsid();
    this.initTimer(this.intialvalue);

    if (environment.enableSSO) {
      this.ssoenabled = environment.enableSSO;
      this.checkSSOCookie();
    } else {
      this.successSSOLogin = true;
      this.router.navigate([{ outlets: { primary: 'login' } }]);
    }
  }

  private setupRouterSubscription() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.currentUrl = event['url'];
        if (this.currentUrl == '/') this.currentUrl = '/landing-page';
      }
      if (event instanceof NavigationEnd) {
        if (this.sharedAuthService.getMsid()) {
          if (this.userRoleSet) {
            this.PixelService.startPixelTracking(event, 'end', '');
          }
        }
        const pathArray = window.location.pathname.split('/')[1];
        const pathSplit = window.location.pathname.split('/');
        let subPath = '';

        if (pathSplit && pathSplit.length && typeof pathSplit[2] != 'undefined') {
          subPath = pathSplit[2];
        }

        if (pathArray === 'uhcproduct-home(sidebar:padu)' || pathArray === 'uhcproduct-home') {
          this.currentPath = true;
        } else {
          this.currentPath = false;
        }
        if (
          ['application-insights', 'application-insights(sidebar:padu)', 'maintenance'].includes(pathArray) ||
          ['stakeholder-view', 'detail-view'].includes(subPath)
        ) {
          this.isPathApplicationInsights = true;
        } else {
          this.isPathApplicationInsights = false;
        }

        this.tcmoptimise.getCurrentPath(pathArray);
        this.checklatest();
      }
    });
  }
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  getLargeOpsToken(){
    this.auth.getEnloToken().subscribe(
      data => {
        if (data) {
          sessionStorage.setItem('enloToken', data.token);
          sessionStorage.setItem('enloTokenExpiry', data.exp);
          this.scheduleTokenRefresh(data.exp);
        }
      },
      error => {
        console.log('Error fetching LargeOps token:', error);
      }
    );
  }

  /**
 * Calculates the time until token expiry and whether the token is expired.
 * @param expiry - Expiry time as a UNIX timestamp (in seconds or string).
 * @returns Object with refreshTime (ms until refresh) and isExpired (boolean).
 */
  getTokenExpiredStatus(expiry:number | string): { refreshTime: number; isExpired: boolean } {
    const expiryNum = Number(expiry);
    if (isNaN(expiryNum) || expiryNum <= 0) {
      return { refreshTime: 0, isExpired: true };
    }
    const expiryTime = expiryNum * 1000;
    const currentTime = Date.now();
     // 60000 ms = 1 minute before expiry
    const refreshTime = expiryTime - currentTime - 60000;
    return {'refreshTime' : refreshTime,'isExpired' : refreshTime <= 0}
  }
  private scheduleTokenRefresh(expiry) {
    const expData = this.getTokenExpiredStatus(expiry);
    if (this.tokenRefreshTimeout) {
      clearTimeout(this.tokenRefreshTimeout);
    }
    this.tokenRefreshTimeout = setTimeout(() => {
      try {
        sessionStorage.removeItem('enloToken');
        sessionStorage.removeItem('enloTokenExpiry');
        this.getLargeOpsToken();
      } catch (e) {
        // handle/log error appropriately
      }
    }, expData?.refreshTime);
  }

  checkSSOCookie() {
    this.showSpinner = true;
    this.successSSOLogin = false;
    const at = sessionStorage.getItem('token');
    if (!at || at === 'undefined') {
      const params = new URLSearchParams(window.location.search);
      this.code = params.get('code');
      Cookie.set('codeCreated', JSON.stringify(true));
      if (!this.code) {
        setTimeout(() => {
          window.location.href = environment.sso_keys.url;
        }, 300);
        if (!localStorage.getItem('returnUrl')) {
          localStorage.setItem('returnUrl', window.location.pathname + window.location.search);
        }
      } else {
        this.activatedRoute.queryParamMap.subscribe(paramMap => {
          this.removeSSOCode(paramMap, 'code');
          this.removeSSOCode(paramMap, 'session_state');
        });
        setTimeout(() => {
          this.setAllTokens(this.code);
        }, 3000);
        this.showSpinner = false;
      }
    } else {
      try {
        const expireDate = new Date(Cookie.get('expires_in')).getTime();
        const currDate = new Date().getTime();
        if (expireDate <= currDate) {
          const refreshTkn = Cookie.get('refresh_token');
          this.setAccessToken(refreshTkn);
          this.showSpinner = false;
        } else {
          this.successSSOLogin = true;
          this.showSpinner = false;
        }
        let enloToken = sessionStorage.getItem('enloToken');
        let enloTokenExpiry = sessionStorage.getItem('enloTokenExpiry');
        let expData =  this.getTokenExpiredStatus(enloTokenExpiry)
        if (!enloToken || enloToken === 'undefined' || expData?.isExpired) {
          this.getLargeOpsToken();
        }else{
          this.scheduleTokenRefresh(enloTokenExpiry);
        }
      } catch (err) {
        console.error('Error during token expiry check or navigation:', err);
        this.showSpinner = false;
      }

    }
  }

  private removeSSOCode(paramMap: ParamMap, key: string) {
    if (!paramMap.has(key)) {
      return;
    }
    const queryParams = {};
    paramMap.keys
      .filter(k => k !== key) // Retain other query parameters
      .forEach(k => (queryParams[k] = paramMap.get(k)));
    this.router.navigate([], { queryParams, replaceUrl: true, relativeTo: this.activatedRoute });
  }

  setAllTokens(code) {
    //sets all tokens when cookie is empty
    this.auth.tokenExchange(code).subscribe(
      data => {
        if (data) {
          Cookie.set('refresh_token', data.refresh_token);
          this.setUserDetails(data);
          this.showSpinner = false;
        }
      },
      error => {
        console.log(error);
      }
    );
    this.getLargeOpsToken();
  }

  setUserDetails(accessdata) {
    this.userRoleSet = false;
    const { sn, givenName, middleName = '', access_token, token, mail, cn, expires_in, secureGroups } = accessdata;

    const fullName = `${sn} , ${givenName} ${middleName}`;
    sessionStorage.setItem('currentUser', JSON.stringify(fullName));
    sessionStorage.setItem('loggedInUserEmail', JSON.stringify(mail));
    const appJwt = JSON.stringify(token).slice(1, -1);
    sessionStorage.setItem('token', appJwt);
    sessionStorage.setItem('MsId', cn);

    //for automation testing script failure issue fix
    localStorage.setItem('currentUser', JSON.stringify(fullName));
    localStorage.setItem('loggedInUserEmail', JSON.stringify(mail));
    localStorage.setItem('MsId', cn);
    localStorage.setItem('secureGroups', JSON.stringify(secureGroups));
    // sessionStorage.setItem('currentUser', JSON.stringify(fullName));
    // sessionStorage.setItem('loggedInUserEmail', JSON.stringify(mail));
    // sessionStorage.setItem('MsId', cn);
    sessionStorage.setItem('secureGroups', JSON.stringify(secureGroups));
    Cookie.set('MsId', cn);
    Cookie.set('fullName', fullName);
    // Scope app JWT cookie to media routes only (video/thumb/etc.) so it isn't sent with other APIs.
    this.sharedAuthService.setMediaTokenCookie(appJwt);
    const config = sessionStorage.getItem('config');
    if (config) sessionStorage.removeItem('config');
    sessionStorage.removeItem('reclassAccess');
    sessionStorage.removeItem('flagAccess');
    this.successSSOLogin = true;
    window?.Rakanto.event('setUserIdentity', { authSystem: 'MSAD', userId: this.sharedAuthService.getMsid() });

    this.AppHubv4Service.getRoleofUser().subscribe((data) => {
      if (data) sessionStorage.setItem('roleOfUser', JSON.stringify(data['result']));
    }, error => {
      console.error('error', error);
    });
    this.saveAccessToken({ access_token, exp: expires_in });
  }

  decodeIDtoken(tkn) {
    this.idToken = jwtDecode(tkn.id_token);
    Cookie.set('MsId', this.idToken.msid);
    Cookie.set('fullName', this.idToken.name);
    sessionStorage.setItem('MsId', this.idToken.msid);
    sessionStorage.setItem('currentUser', this.idToken.name);
    sessionStorage.setItem('loggedInUserEmail', this.idToken.email);
    this.saveAccessToken(tkn);
  }

  saveAccessToken(access_token) {
    let accessData = this.sharedAuthService.getTechAccessData();
    if (accessData) {
      this.role = this.sharedAuthService.getUserRole();
    }
    //saves access token & its expiry into cookies
    this.accessToken = access_token;
    const currenttime = new Date();
    const expiry = currenttime.getTime() + this.accessToken.exp * 1000;
    Cookie.set('access_token', this.accessToken.access_token);
    Cookie.set('expires_in', String(expiry));
    this.successSSOLogin = true;
    this.showSpinner = false;
    const returnUrl = localStorage.getItem('returnUrl') || null;
    if (returnUrl && returnUrl != '/' && returnUrl != '/landing-page') {
      localStorage.removeItem('returnUrl');
      this.router.navigateByUrl(returnUrl);
    }
    // else{
    //   // this.router.navigateByUrl('/landing-page');
    // }
  }

  setAccessToken(token) {
    //retrieves new access token on expiry of prev
    this.auth.getNewAccessToken(token).subscribe(
      data => {
        this.saveAccessToken(data);
        this.showSpinner = false;

        // Access token expired, new access token obtained!
      },
      error => {
        //if token expires or invalid parameters sent
        if (error) {
          this.sharedAuthService.clearMediaTokenCookie();
          Cookie.deleteAll();
          window.location.href = environment.sso_keys.url;
        }
      }
    );
  }
  initTimer(firstTimerValue): void {
    // Timer value initialization
    this.ngIdle.USER_IDLE_TIMER_VALUE_IN_MIN = firstTimerValue;
    this.ngIdle.FINAL_LEVEL_TIMER_VALUE_IN_MIN = firstTimerValue;
    // end

    // Watcher on timer
    this.ngIdle.initilizeSessionTimeout();
    this.ngIdle.userIdlenessChecker.subscribe((status: string) => {
      this.initiateFirstTimer(status);
    });
  }
  initiateFirstTimer = (status: string) => {
    switch (status) {
      case 'INITIATE_TIMER':
        break;

      case 'RESET_TIMER':
        break;

      case 'STOPPED_TIMER':
        this.showSendTimerDialog();
        break;

      default:
        this.idleTimerLeft = this.formatTimeLeft(Number(status));
        break;
    }
  };
  showSendTimerDialog(): void {
    this.setTime();
    const modal = document.getElementById('SessionModal');
    modal.style.display = 'block';
  }
  setTime() {
    let totalSeconds = 0;
    totalSeconds = 180;
    const downloadTimer = setInterval(() => {
      if (totalSeconds <= 0) {
        clearInterval(downloadTimer);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('config');
        sessionStorage.removeItem('landingPageContent');
        Cookie.delete('refresh_token');
        this.sharedAuthService.clearMediaTokenCookie();
        document.getElementById('countdown').innerHTML = 'has been expired ';
      } else {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        document.getElementById('countdown').innerHTML = `will expire in ${minutes}:${seconds}`;
      }
      totalSeconds -= 1;
    }, 1000);
  }
  continue(): void {
    if (window.location.pathname && window.location.pathname.split('/')[1] != '') {
      // Cookie.set('historyUrl', window.location.pathname + window.location.search);
    }
    const modal = document.getElementById('SessionModal');
    modal.style.display = 'none';

    // stop second timer and initiate first timer again
    IdletimeService.runSecondTimer = false;
    this.ngIdle.initilizeSessionTimeout();
    if (!sessionStorage.getItem('token')) {
      this.router.navigate(['/']);
      window.location.reload();
    }
  }
  formatTimeLeft = (time: number) => {
    if (time > 0) {
      let seconds = Math.trunc(time / 1000);
      this.setCircleDasharray(seconds);
      let min = 0;
      if (seconds >= 60) {
        min = Math.trunc(seconds / 60);
        seconds -= min * 60;
      }
      return `${min}:${seconds}`;
    }
  };
  formatSeconds(time: number) {
    if (time > 0) {
      let seconds = Math.trunc(time / 1000);

      this.setCircleDasharray(seconds);

      let min = 0;
      if (seconds >= 60) {
        min = Math.trunc(seconds / 60);
        seconds -= min * 60;
      }
      return [seconds, min];
    }
  }

  setCircleDasharray = (elapsedTime: number) => {
    const inputValue: any = this.intialvalue;
    const timeLimit = inputValue * 60;

    this.timeRemain = elapsedTime / timeLimit;
  };
  saveUserLogoutStats(msId: string) {
    const body = { logOut_at: new Date().toISOString() };
    this.sharedService.createUserStats(msId, body).subscribe(() => { });
  }
  refreshStorage(access_token) {
    //saves access token & its expiry into cookies
    this.accessToken = access_token;
    const currenttime = new Date();
    const expiry = currenttime.getTime() + this.accessToken.exp * 1000;
    Cookie.set('access_token', this.accessToken.access_token);
    Cookie.set('expires_in', String(expiry));
    this.successSSOLogin = true;
    this.showSpinner = false;
  }
  updateAccess(token) {
    //retrieves new access token on expiry of prev
    this.auth.getNewAccessToken(token).subscribe(
      data => {
        this.showSpinner = false;
        this.refreshStorage(data);
        // Access token expired, new access token obtained!
      },
      error => {
        //if token expires or invalid parameters sent
        if (error) {
          window.location.reload();
        }
      }
    );
  }
  refesh() {
    window.location.reload();
  }

  checklatest() {
    const minuteCount = (minutesAfterHour): any => {
      const now = new Date();
      const minutes = now.getMinutes();

      if (minutes == minutesAfterHour) {
        this.tcmoptimise.updateConfig();
      }
    };
    minuteCount(59);
  }

  ngOnDestroy() {
    if (this.tokenRefreshTimeout) {
      clearTimeout(this.tokenRefreshTimeout);
    }
  }
}
